<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Groups</b>
        
      </b-card-header>

      <!-- List group Organizations -->

      <div v-if="memberGroups.length > 0">
        <b-list-group v-for="um in memberGroups" :key="um.id" flush>
          <b-list-group-item>
              {{um.groupName}}
            <img v-if="um.defaultOrg === organizationId " src="static/img/Primary.png" height="21" width="21">
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="memberGroups.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>
              {{ !hasOrganizations ? 'This Organization does not have any Groups.' : 'Howdy!' }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </div>
</template>

<script>
  
  export default {
    name: 'OrganizationGroups',
    props: {
      memberGroups: Array,
      organizationId: Number
    },
    computed: {
      hasOrganizations: function () {
        return this.memberGroups.length > 0
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/OrganizationGroups.vue